import { render, staticRenderFns } from "./UserRolesModal.vue?vue&type=template&id=268dc719"
import script from "./UserRolesModal.vue?vue&type=script&lang=js"
export * from "./UserRolesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports